export const Content = {
    BANNER_HEADING: 'View CPQ Quote Details',
    BANNER_PARAGRAPH: 'View your CPQ details with a innovative Portal.',
    BREADCRUMB_NAME: "View Request",
    PRICING_CALCULATION: "Pricing Calculation ",
    ALL_IN_PRICE: "(All in price)",
    NOTEBANNER:"Add Note",
    NOTEHEADING:"Note",
    APPROVEBANNER:"Approve",
    APPROVEHEADING:"Please confirm your approval of the quote and the selected approver.",
    REJECTBANNER:"Reject",
    REJECTHEADING:"Would you like to reject this quote? Feel free to add a note if needed.",
    CONFIRMBANNER:"Confirm",    
    CONFIRMHEADINGSAMLEADERSHIP:"Thank you for approving the quote.",
    CONFIRMHEADING: "Thank you for approving the quote and selecting the approver.",
    CONFIRMHEADING_POSTDISCOUNT: "Thank you for approving the quote.",
    REQUIREDERROR:"This field is required.",
    APPROVESUCCESS:"Quote was succesfully approved!",
    APPROVETOPRICING:"Quote was succesfully approved by SAM leadership and moved to Pricing Team for approval.",
    CONFIRM:0,
    APPROVE:1,
    NOTE:2,
    REJECT:3
}

export const CustomerStatusConstants=
{
    CUSTOMER:"Customer",
    STATUS:"Quote Status",
    DATE:"Date Created",
    LOCATION:"Location of Buyer",
    OPPORTUNITYNAME:"Opportunity ID",
    OPPORTUNITYTYPE: "Pricing Type",
    AM:"Account Manager",
    PARTNERRESELLER:"Partner / ReSellers",
    SALESLEAD:"Sales Lead",
    AMLEAD:"AM Lead",
    ADDITIONALTEAMMEMBER:"Additional Team Member",
    BROKER:"Broker/Consultant",
    COMMISSION:"Broker Commission",
    ACSUBTYPE:"Account Sub-Type",
    TOTALHEADCOUNT:"Total Head Count",
    UCMSID:"UCMS Id"
}